import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Questionnaire } from '../../../../types';
import { setBlockingAnswers } from '../../../../../../redux/questionnaire/actions';

export const usePutBlockingAnswersToRedux = (questionnaire?: Questionnaire) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const blockingAnswers = questionnaire?.blocking_answers

    if (blockingAnswers) {
      dispatch(setBlockingAnswers(blockingAnswers));
    }
  }, [questionnaire, dispatch]);
};
